import React from 'react';
import CV from '../assets/Akpan Anyiekpon Frank CV.pdf';



import '../styles/Cta.css'

function Cta() {
  return (
  <div>
    <div className='cta'>
        <a href='/contact'  className='letsTalk'>Lets Talk</a>
        <a className='download-btn' href={CV} download>Download CV</a>
    </div>
  </div>
  )
}

export default Cta;